export default {"src":"/_next/static/media/play_basic_icon.b1cddb0a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};